export default __webpack_public_path__ + "static/media/noexpl_05_EN.0a94b56d.png";